// import React from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   ShieldCheck, CloudUpload, Timer, FileCheck2, Layers, ScanSearch,
//   IndianRupee, LayoutDashboard, Archive, ArrowUpRight, Quote, ChevronRight, FileText, Users, Building2,
// } from "lucide-react";
// import Reveal, { SectionLabel } from "../components/Reveal";
// import {
//   Accordion, AccordionContent, AccordionItem, AccordionTrigger,
// } from "../components/ui/accordion.jsx";
// import { Helmet } from "react-helmet-async";

// <Helmet>
//   <title>
//     JustZeta | Digital Certificate & Research Paper Preservation
//   </title>

//   <meta
//     name="description"
//     content="Secure digital certificate and research paper preservation for conferences, hackathons, universities, courses, workshops and institutions."
//   />

//   <meta
//     name="keywords"
//     content="digital certificate storage, certificate preservation, conference certificates, hackathon certificates, research paper archive, JustZeta"
//   />
// <meta property="og:type" content="website" />

// <meta property="og:site_name" content="JustZeta" />

// <meta property="og:title"
// content="JustZeta - Secure Digital Certificate Preservation"
// />

// <meta property="og:description"
// content="Long-term preservation of digital certificates and research papers."
// />

// <meta property="og:image"
// content="https://justzeta.com/logo.png"
// />

// <meta property="og:url"
// content="https://justzeta.com"
// />
// <meta name="twitter:card" content="summary_large_image"/>

// <meta
// name="twitter:title"
// content="JustZeta"
// />

// <meta
// name="twitter:description"
// content="Secure digital certificate preservation."
// />

// <meta
// name="twitter:image"
// content="https://justzeta.com/logo.png"
// />
//   <link
//     rel="canonical"
//     href="https://justzeta.com/"
//   />
// </Helmet>
// const HERO_IMG =
//   "https://images.pexels.com/photos/18545023/pexels-photo-18545023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

// const features = [
//   { icon: CloudUpload, title: "Secure Cloud Storage", desc: "Encrypted at rest and in transit, hosted on redundant infrastructure." },
//   { icon: Timer, title: "Long-Term Preservation", desc: "Guaranteed retention for the exact number of years you configure." },
//   { icon: FileCheck2, title: "Certificate Verification Ready", desc: "Structured records tuned for third-party verification workflows." },
//   { icon: FileText, title: "Research Paper PDF Storage", desc: "Attach the presenter's paper alongside every conference certificate." },
//   { icon: Layers, title: "Organised Candidate Records", desc: "Every participant is indexed, searchable and retrievable in seconds." },
//   { icon: ScanSearch, title: "Fast Digital Access", desc: "Global CDN-backed retrieval, resilient to peak demand." },
//   { icon: IndianRupee, title: "Affordable Pricing", desc: "Starts at ₹1 per person per year — no hidden add-ons, ever." },
//   { icon: LayoutDashboard, title: "Responsive Dashboard Ready", desc: "Institutional admin views, engineered mobile-first." },
//   { icon: Archive, title: "Trusted Digital Archiving", desc: "Modeled on library-grade archival standards, purpose-built for events." },
// ];

// const steps = [
//   { n: "01", title: "Submit participant details", desc: "Upload a CSV or use our onboarding form to register your candidates." },
//   { n: "02", title: "Upload certificates", desc: "Bulk-upload PDF or image certificates. We index and version each file." },
//   { n: "03", title: "Upload conference papers", desc: "Optional. Attach research paper PDFs to each presenter's record." },
//   { n: "04", title: "Preserve for years", desc: "Pick your retention window. We handle the archive — permanently accessible." },
// ];

// const whyChoose = [
//   "Affordable, transparent per-year pricing",
//   "Long-term multi-year preservation",
//   "Professional record management",
//   "Secure encrypted storage",
//   "Easy institutional accessibility",
//   "Research paper archival",
//   "Modern, minimal digital experience",
// ];

// const testimonials = [
//   {
//     quote: "JustZeta gave our annual IEEE conference a permanent home for every presenter's paper and certificate. Setup took an afternoon.",
//     name: "Dr. Meera Kulkarni",
//     role: "Chair, National Conf. on Applied Sciences",
//     img: "https://images.unsplash.com/photo-1514960919797-5ff58c52e5ba?crop=entropy&cs=srgb&fm=jpg",
//   },
//   {
//     quote: "Our alumni still fetch their hackathon certificates five years on. That kind of quiet reliability is priceless.",
//     name: "Rohini Sharma",
//     role: "Program Lead, TechFest Innovations",
//     img: "https://images.unsplash.com/photo-1581841064838-a470c740e8ee?crop=entropy&cs=srgb&fm=jpg",
//   },
//   {
//     quote: "Bulk uploads for 4,000 workshop participants — zero friction, zero downtime. Exactly what an institution needs.",
//     name: "Prof. Ananya Rao",
//     role: "Director, Centre for Continuing Education",
//     img: "https://images.unsplash.com/photo-1770922809545-edc679cdf6d6?crop=entropy&cs=srgb&fm=jpg",
//   },
// ];

// const faqs = [
//   { q: "How long can certificates be stored?", a: "You choose the retention window at onboarding — from 1 year up to a decade or more. Our offer tier begins at 5 years." },
//   { q: "Can conference papers also be stored?", a: "Yes. Each presenter's PDF paper can be attached alongside their certificate under the Conference Certificate + Research Paper plan." },
//   { q: "Can institutions upload in bulk?", a: "Absolutely. Universities and event organisers can bulk-onboard candidates via CSV or spreadsheet import." },
//   { q: "Is data secure?", a: "Every artifact is protected with enterprise-grade encryption in transit and at rest, backed by secure access controls and durable cloud infrastructure." },
//   { q: "Can candidates download their own certificates?", a: "Yes — each candidate gets a verification link that resolves for the entire retention window." },
// ];

// const partnerLogos = [
//   "https://images.unsplash.com/photo-1763929272623-ffeac6713298?crop=entropy&cs=srgb&fm=jpg&w=200",
//   "https://images.unsplash.com/photo-1767482483139-a59556ff7579?crop=entropy&cs=srgb&fm=jpg&w=200",
//   "https://images.unsplash.com/photo-1763929272543-0df093e4f659?crop=entropy&cs=srgb&fm=jpg&w=200",
// ];

// export default function Home() {
//   return (
//     <div data-testid="page-home">
//       {/* HERO */}
//       <section className="relative min-h-[92vh] flex items-center overflow-hidden border-b border-white/10">
//         <div className="absolute inset-0">
//           <img src={HERO_IMG} alt="" className="w-full h-full object-cover opacity-30" />
//           <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/70 to-[#050505]" />
//           <div
//             className="absolute inset-0 opacity-40"
//             style={{
//               backgroundImage:
//                 "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
//               backgroundSize: "80px 80px",
//             }}
//           />
//         </div>

//         <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-32 md:py-40 w-full">
//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
//             <div className="lg:col-span-8">
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ duration: 1 }}
//                 className="overline mb-8"
//               >
//                 <span className="text-[#e60000]">●</span>&nbsp;&nbsp;Est. 2026 · Digital Archival Bureau
//               </motion.div>

//               <motion.h1
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
//                 className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.98] tracking-tight text-white"
//               >
//                 Preserve <span className="italic text-neutral-400">certificates</span> <br />
//                 &amp; research papers <br />
//                 securely for <span className="text-[#e60000]">years.</span>
//               </motion.h1>

//               <motion.p
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.9, delay: 0.2 }}
//                 className="mt-8 max-w-2xl text-lg text-neutral-300 leading-relaxed"
//               >
//                 Long-term digital preservation for conferences, hackathons, courses, workshops,
//                 institutions, and events — engineered for permanence, priced for scale.
//               </motion.p>

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.9, delay: 0.35 }}
//                 className="mt-12 flex flex-col sm:flex-row gap-4"
//               >
//                 <Link
//                   to="/contact"
//                   data-testid="hero-cta-getstarted"
//                   className="group bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 transition-colors"
//                 >
//                   Get Started
//                   <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
//                 </Link>
//                 <Link
//                   to="/contact"
//                   data-testid="hero-cta-contact"
//                   className="border border-white/25 hover:border-white text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 transition-colors"
//                 >
//                   Contact Us
//                 </Link>
//               </motion.div>
//             </div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 1, delay: 0.4 }}
//               className="lg:col-span-4"
//             >
//               <div className="border border-white/15 bg-black/40 backdrop-blur-md p-8">
//                 <div className="overline mb-4">Retention Ledger</div>
//                 <div className="space-y-5">
//                   {/* <Stat label="Certificates archived" value="12,480+" />
//                   <Stat label="Research papers preserved" value="1,904" /> */}
//                   <Stat label="Retention years available" value="1 → 50" />
//                   <Stat label="Uptime SLA" value="99.99%" />
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* PARTNER MARQUEE */}
//       {/* <section className="border-b border-white/10 py-10 overflow-hidden">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <div className="overline mb-8 text-center">Trusted by institutions & event organisers</div>
//         </div>
//         <div className="relative">
//           <div className="flex gap-24 marquee-track whitespace-nowrap" style={{ width: "max-content" }}>
//             {[...partnerLogos, ...partnerLogos, ...partnerLogos, ...partnerLogos].map((src, i) => (
//               <div key={i} className="flex items-center gap-4 opacity-60 hover:opacity-100 transition-opacity">
//                 <img src={src} alt="" className="h-8 w-8 object-contain grayscale brightness-200 contrast-0 invert" />
//                 <span className="font-serif-display text-2xl text-neutral-300">
//                   {["Meridian University", "Kaiser Institute", "Northwind College", "TechFest Global", "Nova Research", "Continental Academy"][i % 6]}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section> */}

//       {/* FEATURES */}
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <Reveal>
//             <SectionLabel index={1}>Capabilities</SectionLabel>
//             <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
//               Everything an organiser needs. <span className="italic text-neutral-500">Nothing they don't.</span>
//             </h2>
//           </Reveal>

//           <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10">
//             {features.map((f, i) => (
//               <Reveal key={f.title} delay={i * 0.04} y={12}>
//                 <div
//                   data-testid={`feature-card-${i}`}
// className="group bg-[#0a0a0a] hover:bg-[#111] p-10 h-full transition-colors border-b border-white/0"                >
//                   <div className="w-11 h-11 border border-white/15 flex items-center justify-center mb-8 group-hover:border-[#e60000] group-hover:bg-[#e60000]/10 transition-all">
//                     <f.icon size={18} className="text-[#e60000]" strokeWidth={1.5} />
//                   </div>
//                   <h3 className="font-serif-display text-2xl mb-3 text-white">{f.title}</h3>
//                   <p className="text-neutral-400 text-[15px] leading-relaxed">{f.desc}</p>
//                 </div>
//               </Reveal>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* HOW IT WORKS */}
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <Reveal>
//             <SectionLabel index={2}>Process</SectionLabel>
//             <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
//               <h2 className="md:col-span-8 font-serif-display text-4xl md:text-6xl leading-[1.02]">
//                 Four steps between your event and <span className="italic text-neutral-500">forever.</span>
//               </h2>
//               <p className="md:col-span-4 text-neutral-400 leading-relaxed">
//                 From CSV import to permanent, cryptographically-sealed storage — the entire
//                 archival flow is engineered to be boringly reliable.
//               </p>
//             </div>
//           </Reveal>

//           <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {steps.map((s, i) => (
//               <Reveal key={s.n} delay={i * 0.08}>
//                 <div className="border border-white/10 bg-[#0a0a0a] p-8 h-full hover:border-[#e60000]/60 transition-colors">
//                   <div className="font-mono text-[#e60000] text-sm tracking-widest">{s.n}</div>
//                   <h3 className="font-serif-display text-2xl mt-6">{s.title}</h3>
//                   <p className="text-neutral-400 mt-4 leading-relaxed text-[15px]">{s.desc}</p>
//                 </div>
//               </Reveal>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* PRICING PREVIEW */}
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <Reveal>
//             <SectionLabel index={3}>Pricing Preview</SectionLabel>
//             <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
//               Priced per person, <span className="italic text-neutral-500">per year.</span>
//             </h2>
//           </Reveal>

//           <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-6">
//             <PricePreviewCard
//               badge="Certificates"
//               title="Digital Certificate Preservation"
//               price="₹1"
//               suffix="/ person / year + GST"
//               caption="Offer tier · Minimum 25 candidates & 5 years"
//               alt="Standard tier from ₹5 / person / year + GST"
//               icon={ShieldCheck}
//             />
//             <PricePreviewCard
//               badge="Conference + Papers"
//               title="Certificate + Research Paper"
//               price="₹5"
//               suffix="/ presenter / year + GST"
//               caption="Offer tier · Minimum 25 presenters & 5 years"
//               alt="Standard tier from ₹15 / presenter / year + GST"
//               icon={FileText}
//               accent
//             />
//           </div>

//           <div className="mt-12 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//             <Link
//               to="/pricing"
//               data-testid="home-view-pricing"
//               className="bg-white text-black px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 hover:bg-neutral-200 transition-colors"
//             >
//               View Full Pricing <ChevronRight size={16} />
//             </Link>
//             <span className="text-neutral-500 text-sm">
//               Includes an interactive calculator with instant savings estimate.
//             </span>
//           </div>
//         </div>
//       </section>

//       {/* WHY CHOOSE */}
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
//             <div className="md:col-span-5">
//               <SectionLabel index={4}>Why JustZeta</SectionLabel>
//             <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
//   Built to preserve what <span className="italic text-neutral-500">matters most.</span>
// </h2>
//               <p className="mt-6 text-neutral-400 leading-relaxed max-w-md">
//                 Every architectural choice at JustZeta answers a single question: will this record
//                 still be accessible ten years from now? So far the answer is yes.
//               </p>
//             </div>
//             <div className="md:col-span-7">
//               <ul className="border-t border-white/10">
//                 {whyChoose.map((w, i) => (
//                   <Reveal key={w} delay={i * 0.05}>
//                     <li className="flex items-center justify-between py-6 border-b border-white/10 group">
//                       <div className="flex items-center gap-6">
//                         <span className="font-mono text-[#e60000] text-xs tracking-widest">
//                           {String(i + 1).padStart(2, "0")}
//                         </span>
//                         <span className="text-lg md:text-xl font-serif-display text-white">{w}</span>
//                       </div>
//                       {/* <ArrowUpRight size={18} className="text-neutral-600 group-hover:text-[#e60000] transition-colors" /> */}
//                     </li>
//                   </Reveal>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* TESTIMONIALS */}
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={5}>Testimonials</SectionLabel>
//           <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
//             What organisers will say <span className="italic text-neutral-500">years later.</span>
//           </h2>
//           <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
//             {testimonials.map((t, i) => (
//               <Reveal key={t.name} delay={i * 0.08}>
//                 <div className="border border-white/10 bg-[#0a0a0a] p-8 h-full flex flex-col">
//                   <Quote className="text-[#e60000]" size={20} strokeWidth={1.5} />
//                   <p className="mt-6 text-neutral-200 leading-relaxed font-serif-display text-xl">
//                     &ldquo;{t.quote}&rdquo;
//                   </p>
//                   <div className="mt-auto pt-8 flex items-center gap-4 border-t border-white/10">
//                     <img src={t.img} alt="" className="w-11 h-11 object-cover grayscale" />
//                     <div>
//                       <div className="text-white text-sm">{t.name}</div>
//                       <div className="text-neutral-500 text-xs uppercase tracking-widest">{t.role}</div>
//                     </div>
//                   </div>
//                 </div>
//               </Reveal>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* FAQ */}
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
//           <div className="md:col-span-5">
//             <SectionLabel index={6}>Frequently asked</SectionLabel>
//             <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
//               Answers to the questions organisers ask most.
//             </h2>
//             <p className="mt-6 text-neutral-400">
//               Something else on your mind?{" "}
//               <Link to="/contact" className="text-white hover-underline" data-testid="faq-contact-link">
//                 Write to us.
//               </Link>
//             </p>
//           </div>
//           <div className="md:col-span-7">
//             <Accordion type="single" collapsible className="w-full">
//               {faqs.map((f, i) => (
//                 <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10">
//                   <AccordionTrigger
//                     data-testid={`faq-trigger-${i}`}
//                     className="text-left font-serif-display text-xl md:text-2xl py-6 hover:no-underline hover:text-[#e60000]"
//                   >
//                     {f.q}
//                   </AccordionTrigger>
//                   <AccordionContent className="text-neutral-400 leading-relaxed text-[15px] pb-6">
//                     {f.a}
//                   </AccordionContent>
//                 </AccordionItem>
//               ))}
//             </Accordion>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-24 md:py-10 relative overflow-hidden">
//         <div className="absolute inset-0 opacity-40 pointer-events-none"
//              style={{ backgroundImage: "radial-gradient(circle at 50% 50%, rgba(230,0,0,0.15), transparent 60%)" }} />
//         <div className="max-w-5xl mx-auto px-6 md:px-10 text-center relative">
//           <SectionLabel index={7}>Ready?</SectionLabel>
//           <h2 className="font-serif-display text-5xl md:text-7xl mt-8 leading-[1.02]">
//             Ready to digitise <br />
//             <span className="italic text-neutral-500">your event?</span>
//           </h2>
//           <p className="mt-8 text-neutral-400 max-w-xl mx-auto">
//             Give your participants an artefact they can still verify a decade from now.
//           </p>
//           <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
//             <Link
//               to="/contact"
//               data-testid="cta-contact"
//               className="border border-white/30 hover:border-white text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em]"
//             >
//               Contact
//             </Link>
//             <Link
//               to="/pricing"
//               data-testid="cta-getstarted"
//               className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
//             >
//               Get Started <ArrowUpRight size={18} />
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// const Stat = ({ label, value }) => (
//   <div className="flex items-center justify-between border-b border-white/10 pb-4 last:border-b-0 last:pb-0">
//     <span className="text-neutral-500 text-xs uppercase tracking-widest">{label}</span>
//     <span className="font-mono-data text-white text-lg">{value}</span>
//   </div>
// );

// const PricePreviewCard = ({ badge, title, price, suffix, caption, alt, icon: Icon, accent }) => (
//   <div className={`border p-10 h-full ${accent ? "border-[#e60000]/60 bg-gradient-to-br from-[#1a0000] to-[#0a0000]" : "border-white/10 bg-[#0a0a0a]"}`}>
//     <div className="flex items-start justify-between">
//       <span className="overline">{badge}</span>
//       <div className={`w-10 h-10 border ${accent ? "border-[#e60000]" : "border-white/15"} flex items-center justify-center`}>
//         <Icon size={16} className={accent ? "text-[#e60000]" : "text-white"} strokeWidth={1.5} />
//       </div>
//     </div>
//     <h3 className="font-serif-display text-3xl mt-8">{title}</h3>
//     <div className="mt-8 flex items-baseline gap-3">
//       <span className="font-mono-data text-6xl text-white">{price}</span>
//       <span className="text-neutral-500">{suffix}</span>
//     </div>
//     <p className="mt-4 text-neutral-400 text-sm">{caption}</p>
//     <p className="mt-2 text-neutral-500 text-xs">{alt}</p>
//   </div>
// );
// <script
// type="application/ld+json"
// dangerouslySetInnerHTML={{
// __html: JSON.stringify({

// "@context":"https://schema.org",

// "@type":"Organization",

// "name":"JustZeta",

// "url":"https://justzeta.com",

// "logo":"https://justzeta.com/logo.png",

// "email":"contact@justzeta.com"

// })
// }}
// />
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ShieldCheck, CloudUpload, Timer, FileCheck2, Layers, ScanSearch,
  IndianRupee, LayoutDashboard, Archive, ArrowUpRight, Quote, ChevronRight, FileText, Users, Building2,
} from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion.jsx";
import { Helmet } from "react-helmet-async";

const HERO_IMG =
  "https://images.pexels.com/photos/18545023/pexels-photo-18545023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const features = [
  { icon: CloudUpload, title: "Bulk Certificate Generation", desc: "Generate thousands of certificates instantly by uploading a CSV or Excel file." },
  { icon: Timer, title: "Long-Term Certificate Access", desc: "Provide participants with guaranteed access to download their certificates for up to 50 years based on your plan." },
  { icon: FileCheck2, title: "QR Code Verification", desc: "Every certificate includes a secure QR code for instant, third-party authenticity verification." },
  { icon: FileText, title: "Conference Paper/Abstract Display", desc: "Attach and display the presenter's research paper PDF directly alongside their event certificate (provided the copyright document is submitted)." },
  { icon: Layers, title: "Custom Templates", desc: "Upload your organization's custom certificate designs or design custom certificate and map participant data dynamically." },
  { icon: ScanSearch, title: "Fast Certificate Retrieval", desc: "Global CDN-backed access ensures participants and verifiers can view records in seconds." },
  { icon: IndianRupee, title: "Affordable Pricing", desc: "Starts at ₹1 per person per year — simple, transparent pricing with no hidden fees." },
  { icon: LayoutDashboard, title: "Organization Dashboard", desc: "A centralized, mobile-responsive hub to manage events, participants, and certificate distributions." },
  { icon: Archive, title: "Comprehensive Event Management", desc: "Manage hackathons, workshops, internships, and conferences seamlessly from a single workspace." },
];

const steps = [
  { n: "01", title: "Submit request for onboarding", desc: "Initiate your organization's onboarding request. Once verification is complete, you gain secure access." },
  { n: "02", title: "Create event", desc: "Set up your event details and configure your participant list via bulk CSV or Excel upload." },
  { n: "03", title: "Finalize certificate", desc: "Import your custom template and define its structure, or choose from our formal, predefined templates." },
  { n: "04", title: "Distribute & verify", desc: "Issue certificates to participants. Anyone can instantly verify authenticity using the embedded QR codes for years to come as per plan." },
];

const whyChoose = [
  "Bulk generation from CSV or Excel",
  "Instant QR code based verification",
  "Organization dashboard for event management",
  "Custom certificate template support",
  "Integrated research paper display",
  "Long-term certificate access and download",
  "Affordable, transparent per-year pricing",
];

const testimonials = [
  {
    quote: "JustZeta streamlined our entire annual IEEE conference. We generated and distributed certificates with attached research papers in a single afternoon.",
    name: "Dr. Meera Kulkarni",
    role: "Chair, National Conf. on Applied Sciences",
    img: "https://images.unsplash.com/photo-1514960919797-5ff58c52e5ba?crop=entropy&cs=srgb&fm=jpg",
  },
  {
    quote: "The QR code verification has been a game-changer for our hackathons. Verifying authenticity for our alumni is now instant and hassle-free.",
    name: "Rohini Sharma",
    role: "Program Lead, TechFest Innovations",
    img: "https://images.unsplash.com/photo-1581841064838-a470c740e8ee?crop=entropy&cs=srgb&fm=jpg",
  },
  {
    quote: "Bulk generating certificates for 4,000 workshop participants was seamless with zero friction. It is exactly the SaaS platform our institution needed.",
    name: "Prof. Ananya Rao",
    role: "Director, Centre for Continuing Education",
    img: "https://images.unsplash.com/photo-1770922809545-edc679cdf6d6?crop=entropy&cs=srgb&fm=jpg",
  },
];

const faqs = [
  { q: "How do I generate certificates in bulk?", a: "You can easily bulk-onboard candidates by uploading a CSV or Excel file. Our system will map the data to your custom templates and generate the certificates instantly." },
  { q: "Can conference papers be displayed alongside certificates?", a: "Yes. Under the Conference Certificate + Research Paper plan, each presenter's PDF paper can be attached and viewed directly on their certificate page." },
  { q: "How does the certificate verification work?", a: "Every certificate generated on JustZeta includes a unique QR code. Anyone can scan it to instantly verify the certificate's authenticity against our secure database." },
  { q: "Can participants download their own certificates?", a: "Yes. Each participant receives a secure link to access, view, and download their certificate for the entire duration of your selected plan (up to 50 years)." },
  { q: "Can we use our own certificate designs?", a: "Absolutely. Organizations can upload their custom certificate templates, and our platform will overlay the participant details automatically." },
];

const partnerLogos = [
  "https://images.unsplash.com/photo-1763929272623-ffeac6713298?crop=entropy&cs=srgb&fm=jpg&w=200",
  "https://images.unsplash.com/photo-1767482483139-a59556ff7579?crop=entropy&cs=srgb&fm=jpg&w=200",
  "https://images.unsplash.com/photo-1763929272543-0df093e4f659?crop=entropy&cs=srgb&fm=jpg&w=200",
];

export default function Home() {
  return (
    <div data-testid="page-home">
      <Helmet>
        <title>
          Just Zeta | Certificate Generation, Management & Verification
        </title>

        <meta
          name="description"
          content="Generate, manage, and verify digital certificates for conferences, hackathons, universities, courses, workshops and institutions."
        />
<link rel="icon" href="../assets/logo.png" type="image/x-icon" />
        <meta
          name="keywords"
          content="JustZeta, Certiicate Generator, Just Zeta, JustZetaa, JustZetta, Just Zetta, JustZeeta, JustZta, Just Zta, JustZetha, JustSeta, JustJeta, JustZetaa, JustZete, JustZitaa, JustZitaa, JustZeto, JustZita, JustZata, JustZetra, JustZetraa, JustZet, Just Zet, JustZetta, JustZtaa, JustZeata, JustZeata, JustZeya, JustZeyaa, JustZehta, JustZeita, JustZyta, JustZytaa, JustZitta, JustZeetaa, JustZeatah, JustZeetar, JustZetoa, JustZettaa, JustZetar, JustZetar, JustZitaa, JustZeetra, JustZetah, JustZitaa, JustZettah, JustZetarh, JustZettaS, JustZett, JustZethaa, JustZetaaa, Digital Certificate Generation, Certificate Generator, Online Certificate Generator, Certificate Verification, Digital Certificate Verification, Certificate Validation, Certificate Authentication, Certificate Issuance, Certificate Management, Certificate Tracking, Certificate Security, Certificate Automation, Digital Credentials, Secure Digital Credentials, Digital Credential Platform, Credential Verification, Credential Management, Academic Certificates, Educational Certificates, University Certificates, Institute Certificates, School Certificates, College Certificates, Course Certificates, Training Certificates, Workshop Certificates, Internship Certificates, Hackathon Certificates, Conference Certificates, Seminar Certificates, Event Certificates, Webinar Certificates, Professional Certificates, Employee Certificates, Appreciation Certificates, Participation Certificates, Completion Certificates, Achievement Certificates, Excellence Certificates, Merit Certificates, Award Certificates, Volunteer Certificates, Organization Certificates, QR Code Certificates, Verifiable Certificates, Blockchain Certificates, E-Certificates, Online Certificates, Tamper-Proof Certificates, Secure Certificate Platform, Digital Certificate Generation, Certificate Verification, Digital Certificate Verification, Certificate Management, Online Certificate Generator, QR Code Certificate, Secure Digital Credentials, Educational Certificates, Course Certificates, Workshop Certificates, Internship Certificates, Hackathon Certificates, Conference Certificates, Event Certificates, University Certificates, Institute Certificates, Professional Certificates, Employee Certificates, Digital Credential Platform, Certificate Authentication, Certificate Issuance, Certificate Validation, Credential Verification, Academic Certificates, Organization Certificates, Certificate Tracking, Certificate Security, Digital Credentials, Certificate Automation, certificate generation, certificate management, Certificate Manager, QR code verification, bulk certificates, event certificates, JustZeta"
        />
        <meta property="og:type" content="website" />

        <meta property="og:site_name" content="JustZeta" />

        <meta property="og:title"
        content="Just Zeta - Certificate Management Platform"
        />

        <meta property="og:description"
        content="Generate, manage, and verify certificates from a single platform."
        />

        <meta property="og:image"
        content="https://justzeta.com/logo.png"
        />

        <meta property="og:url"
        content="https://justzeta.com"
        />
        <meta name="twitter:card" content="summary_large_image"/>

        <meta
        name="twitter:title"
        content="JustZeta"
        />

        <meta
        name="twitter:description"
        content="The complete certificate management solution."
        />

        <meta
        name="twitter:image"
        content="https://justzeta.com/logo.png"
        />
        <link
          rel="canonical"
          href="https://justzeta.com/"
        />
      </Helmet>

      {/* HERO */}
      <section className="relative min-h-[92vh] flex items-center overflow-hidden border-b border-white/10">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/70 to-[#050505]" />
          <div
            className="absolute inset-0 opacity-40"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
              backgroundSize: "80px 80px",
            }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-32 md:py-10 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
            <div className="lg:col-span-8">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="overline mb-8"
              >
                <span className="text-[#e60000]">●</span>&nbsp;&nbsp; Certificate Management Platform
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.98] tracking-tight text-white"
              >
                Generate, <span className="italic text-neutral-400">manage</span> <br />
                &amp; verify digital certificates <br />
                from a <span className="text-[#e60000]">single platform.</span>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.2 }}
                className="mt-8 max-w-2xl text-lg text-neutral-300 leading-relaxed"
              >
                The complete certificate management solution for conferences, hackathons, courses, short-term courses, internships, workshops,
                institutions, and events — engineered for scale, built for authenticity.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.35 }}
                className="mt-12 flex flex-col sm:flex-row gap-4"
              >
                <Link
                  to="/contact"
                  data-testid="hero-cta-getstarted"
                  className="group bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 transition-colors"
                >
                  Get Started
                  <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </Link>
                <Link
                  to="/contact"
                  data-testid="hero-cta-contact"
                  className="border border-white/25 hover:border-white text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 transition-colors"
                >
                  Contact Us
                </Link>
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.4 }}
              className="lg:col-span-4"
            >
              <div className="border border-white/15 bg-black/40 backdrop-blur-md p-8">
                <div className="overline mb-4">Platform Metrics</div>
                {/* <div className="space-y-5">
                  <Stat label="Certificates archived" value="12,480+" />
                  <Stat label="Research papers preserved" value="1,904" /> 
                  <Stat label="Certificate access duration" value="1 → 50 Y" />
                  <Stat label="Uptime SLA" value="99.99%" />
                </div>*/}
                <div className="space-y-5">
  <Stat label="Service Availability" value="99.99% Uptime" />
</div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* PARTNER MARQUEE */}
      {/* <section className="border-b border-white/10 py-10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="overline mb-8 text-center">Trusted by institutions & event organisers</div>
        </div>
        <div className="relative">
          <div className="flex gap-24 marquee-track whitespace-nowrap" style={{ width: "max-content" }}>
            {[...partnerLogos, ...partnerLogos, ...partnerLogos, ...partnerLogos].map((src, i) => (
              <div key={i} className="flex items-center gap-4 opacity-60 hover:opacity-100 transition-opacity">
                <img src={src} alt="" className="h-8 w-8 object-contain grayscale brightness-200 contrast-0 invert" />
                <span className="font-serif-display text-2xl text-neutral-300">
                  {["Meridian University", "Kaiser Institute", "Northwind College", "TechFest Global", "Nova Research", "Continental Academy"][i % 6]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* FEATURES */}
      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <SectionLabel index={1}>Capabilities</SectionLabel>
            <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
              Everything an organiser needs. <span className="italic text-neutral-500">Nothing they don't.</span>
            </h2>
          </Reveal>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10">
            {features.map((f, i) => (
              <Reveal key={f.title} delay={i * 0.04} y={12}>
                <div
                  data-testid={`feature-card-${i}`}
className="group bg-[#0a0a0a] hover:bg-[#111] p-10 h-full transition-colors border-b border-white/0"                >
                  <div className="w-11 h-11 border border-white/15 flex items-center justify-center mb-8 group-hover:border-[#e60000] group-hover:bg-[#e60000]/10 transition-all">
                    <f.icon size={18} className="text-[#e60000]" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif-display text-2xl mb-3 text-white">{f.title}</h3>
                  <p className="text-neutral-400 text-[15px] leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <SectionLabel index={2}>Process</SectionLabel>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
              <h2 className="md:col-span-8 font-serif-display text-4xl md:text-6xl leading-[1.02]">
                Four steps to generate, distribute and<span className="text-[#e60000]">verify certificates.</span>
              </h2>
              <p className="md:col-span-4 text-neutral-400 leading-relaxed">
                From bulk CSV imports to instant QR code verification — the entire certificate lifecycle
                is managed effortlessly from one secure dashboard.
              </p>
            </div>
          </Reveal>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08}>
                <div className="border border-white/10 bg-[#0a0a0a] p-8 h-full hover:border-[#e60000]/60 transition-colors">
                  <div className="font-mono text-[#e60000] text-sm tracking-widest">{s.n}</div>
                  <h3 className="font-serif-display text-2xl mt-6">{s.title}</h3>
                  <p className="text-neutral-400 mt-4 leading-relaxed text-[15px]">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING PREVIEW */}
      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <SectionLabel index={3}>Pricing Preview</SectionLabel>
            <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
              Priced per person, <span className="text-[#e60000]">per year.</span>
            </h2>
          </Reveal>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-6">
            <PricePreviewCard
              badge="Certificates"
              title="Digital Certificate Management"
              price="₹1"
              suffix="/ person / year + GST"
              caption="Offer tier · Minimum 25 candidates & 5 years access"
              alt="Standard tier from ₹5 / person / year + GST"
              icon={ShieldCheck}
            />
            <PricePreviewCard
              badge="Conference + Papers"
              title="Certificate + Research Paper"
              price="₹5"
              suffix="/ presenter / year + GST"
              caption="Offer tier · Minimum 25 presenters & 5 years access"
              alt="Standard tier from ₹15 / presenter / year + GST"
              icon={FileText}
              accent
            />
          </div>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <Link
              to="/pricing"
              data-testid="home-view-pricing"
              className="bg-white text-black px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 hover:bg-neutral-200 transition-colors"
            >
              View Full Pricing <ChevronRight size={16} />
            </Link>
            <span className="text-neutral-500 text-sm">
              Includes an interactive calculator with instant savings estimate.
            </span>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
              <SectionLabel index={4}>Why JustZeta</SectionLabel>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
  Built to scale your <span className="text-[#e60000]">Certifications.</span>
</h2>
              <p className="mt-6 text-neutral-400 leading-relaxed max-w-md">
                Every feature in JustZeta is designed to streamline how organizations generate, 
                distribute, and verify certificates at scale.
              </p>
            </div>
            <div className="md:col-span-7">
              <ul className="border-t border-white/10">
                {whyChoose.map((w, i) => (
                  <Reveal key={w} delay={i * 0.05}>
                    <li className="flex items-center justify-between py-6 border-b border-white/10 group">
                      <div className="flex items-center gap-6">
                        <span className="font-mono text-[#e60000] text-xs tracking-widest">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="text-lg md:text-xl font-serif-display text-white">{w}</span>
                      </div>
                      {/* <ArrowUpRight size={18} className="text-neutral-600 group-hover:text-[#e60000] transition-colors" /> */}
                    </li>
                  </Reveal>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      {/* <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={5}>Testimonials</SectionLabel>
          <h2 className="font-serif-display text-4xl md:text-6xl mt-6 max-w-3xl leading-[1.02]">
            What organizers say <span className="italic text-neutral-500">about JustZeta.</span>
          </h2>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t, i) => (
              <Reveal key={t.name} delay={i * 0.08}>
                <div className="border border-white/10 bg-[#0a0a0a] p-8 h-full flex flex-col">
                  <Quote className="text-[#e60000]" size={20} strokeWidth={1.5} />
                  <p className="mt-6 text-neutral-200 leading-relaxed font-serif-display text-xl">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <div className="mt-auto pt-8 flex items-center gap-4 border-t border-white/10">
                    <img src={t.img} alt="" className="w-11 h-11 object-cover grayscale" />
                    <div>
                      <div className="text-white text-sm">{t.name}</div>
                      <div className="text-neutral-500 text-xs uppercase tracking-widest">{t.role}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQ */}
      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <SectionLabel index={5}>Frequently asked</SectionLabel>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
              Answers to the questions organizers ask most.
            </h2>
            <p className="mt-6 text-neutral-400">
              Something else on your mind?{" "}
              <Link to="/contact" className="text-white hover-underline" data-testid="faq-contact-link">
                Write to us.
              </Link>
            </p>
          </div>
          <div className="md:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif-display text-xl md:text-2xl py-6 hover:no-underline hover:text-[#e60000]"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-neutral-400 leading-relaxed text-[15px] pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-10 relative overflow-hidden">
        <div className="absolute inset-0 opacity-40 pointer-events-none"
             style={{ backgroundImage: "radial-gradient(circle at 50% 50%, rgba(230,0,0,0.15), transparent 60%)" }} />
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center relative">
          <SectionLabel index={6}>Ready?</SectionLabel>
          <h2 className="font-serif-display text-5xl md:text-7xl mt-8 leading-[1.02]">
            Ready to upgrade <br />
            <span className="text-[#e60000]">your certificate workflow?</span>
          </h2>
          <p className="mt-8 text-neutral-400 max-w-xl mx-auto">
            Generate and issue verifiable certificates for your next event in minutes.
          </p>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              data-testid="cta-contact"
              className="border border-white/30 hover:border-white text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em]"
            >
              Contact
            </Link>
            <Link
              to="/pricing"
              data-testid="cta-getstarted"
              className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
            >
              Get Started <ArrowUpRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context":"https://schema.org",
            "@type":"Organization",
            "name":"JustZeta",
            "url":"https://justzeta.com",
            "logo":"https://justzeta.com/logo.png",
            "email":"contact@justzeta.com"
          })
        }}
      />
    </div>
  );
}

const Stat = ({ label, value }) => (
  <div className="flex items-center justify-between border-b border-white/10 pb-4 last:border-b-0 last:pb-0">
    <span className="text-neutral-500 text-xs uppercase tracking-widest">{label}</span>
    <span className="font-mono-data text-white text-lg">{value}</span>
  </div>
);

const PricePreviewCard = ({ badge, title, price, suffix, caption, alt, icon: Icon, accent }) => (
  <div className={`border p-10 h-full ${accent ? "border-[#e60000]/60 bg-gradient-to-br from-[#1a0000] to-[#0a0000]" : "border-white/10 bg-[#0a0a0a]"}`}>
    <div className="flex items-start justify-between">
      <span className="overline">{badge}</span>
      <div className={`w-10 h-10 border ${accent ? "border-[#e60000]" : "border-white/15"} flex items-center justify-center`}>
        <Icon size={16} className={accent ? "text-[#e60000]" : "text-white"} strokeWidth={1.5} />
      </div>
    </div>
    <h3 className="font-serif-display text-3xl mt-8">{title}</h3>
    <div className="mt-8 flex items-baseline gap-3">
      <span className="font-mono-data text-6xl text-white">{price}</span>
      <span className="text-neutral-500">{suffix}</span>
    </div>
    <p className="mt-4 text-neutral-400 text-sm">{caption}</p>
    <p className="mt-2 text-neutral-500 text-xs">{alt}</p>
  </div>
);